if ($('.profile_page.not-logged-in').length) {
    // DISPLAY POPUP
    setTimeout(function() {
        $(function() {
            $(".popup_bg").show();
            $(".login-modal").addClass("active");
        });
    }, 100);
}
